import React from "react";
import LeaderBoardTableItem from "./leaderboard-table-item";
import { useTranslation } from "react-i18next";
import "./leaderboard-table.css";

const LeaderBoardTable = ({ teams, currentTeam }) => {
  const { t } = useTranslation();

  return (
    <table className="leaderboard-table" data-testid="leaderboard-table">
      <thead>
        <tr>
          <th data-testid="position-header">
            {t("dashboard.leaderboard.table.header.position")}
          </th>
          <th className="header-team" data-testid="team-header">
            {t("dashboard.leaderboard.table.header.team")}
          </th>
          <th data-testid="wins-header">
            {t("dashboard.leaderboard.table.header.wins")}
          </th>
          <th data-testid="losses-header">
            {t("dashboard.leaderboard.table.header.losses")}
          </th>
          <th data-testid="score-header">
            {t("dashboard.leaderboard.table.header.score")}
          </th>
        </tr>
      </thead>
      <tbody>
        {teams.map((team, index) => (
          <LeaderBoardTableItem
            index={index}
            team={team}
            currentTeam={currentTeam}
            key={team.team_id}
          />
        ))}
      </tbody>
    </table>
  );
};

export default LeaderBoardTable;
